var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Summary',{attrs:{"recData":_vm.recData}}),_c('RecPayRelatedList',{attrs:{"hideAction":_vm.recData.InvoiceRecTotal === 0,"data":_vm.recData,"dataList":_vm.recData.RecPayList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }